<template>
  <div class>
    <div class="products-container">
      <div class="container">
        <hometitle :title="productsTitle" :subtitle="productsSubTitle"></hometitle>
        <div class="row" style="margin-bottom: 20px;">
          <img class="col-12" src="http://gwweb.oss-cn-shenzhen.aliyuncs.com/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HoemTitle from '../components/HomeTitle'
export default {
  data() {
    return {
      productsTitle: '合作伙伴',
      productsSubTitle: 'Partner',
      partnerData: []
    }
  },
  methods: {
  },
  created() {
  },
  components: {
    hometitle: HoemTitle
  }
}
</script>
<style scoped>
@media (max-width: 768px) {
  .products-items {
    margin-top: 20px;
  }
}

.products-container {
  padding-top: 40px;
  padding-bottom: 40px;
}

.products-link {
  display: block;
  border: 1px solid #ccc;
  margin-bottom: 20px;

}

.products-img {
  overflow: hidden;
  text-align: center;
  /* padding: 20px 30px; */
}
.products-img img {
  width: 100%;
  background-position: center center;
}
</style>